const TARGET_BYTES = 800 * 1024;
const MAX_DIMENSION = 1920;
const MIN_DIMENSION = 640;
const PHOTO_FIELDS = new Set(['images', 'image']);

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => { URL.revokeObjectURL(url); resolve(image); };
    image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('手机无法读取这张照片，请改用JPG格式')); };
    image.src = url;
  });
}

function toJpeg(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('照片压缩失败，请重新选择')), 'image/jpeg', quality);
  });
}

function jpegName(name) {
  return (name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
}

export async function compressImage(file) {
  if (!file) return file;
  const isImage = (file.type || '').startsWith('image/') || /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || '');
  if (!isImage) throw new Error('只能上传照片文件');
  if (file.size <= TARGET_BYTES) return file;

  const image = await loadImage(file);
  const naturalWidth = image.naturalWidth || image.width;
  const naturalHeight = image.naturalHeight || image.height;
  if (!naturalWidth || !naturalHeight) throw new Error('照片尺寸无效');

  const scale = Math.min(1, MAX_DIMENSION / Math.max(naturalWidth, naturalHeight));
  let width = Math.max(1, Math.round(naturalWidth * scale));
  let height = Math.max(1, Math.round(naturalHeight * scale));
  let quality = 0.86;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) throw new Error('当前浏览器不支持照片压缩');

  for (let attempt = 0; attempt < 20; attempt += 1) {
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);
    const blob = await toJpeg(canvas, quality);
    if (blob.size <= TARGET_BYTES) {
      return new File([blob], jpegName(file.name), { type: 'image/jpeg', lastModified: Date.now() });
    }
    if (quality > 0.5) quality = Math.max(0.5, quality - 0.08);
    else {
      if (Math.max(width, height) <= MIN_DIMENSION) break;
      width = Math.max(1, Math.round(width * 0.82));
      height = Math.max(1, Math.round(height * 0.82));
      quality = 0.78;
    }
  }
  throw new Error('照片压缩后仍超过800KB，请换一张照片');
}

export async function compressFormDataImages(formData) {
  const output = new FormData();
  for (const [field, value] of formData.entries()) {
    if (PHOTO_FIELDS.has(field) && value instanceof File) {
      const compressed = await compressImage(value);
      output.append(field, compressed, compressed.name);
    } else {
      output.append(field, value);
    }
  }
  return output;
}
